import type { SxProps } from "@mui/material";
import { Autocomplete, Box, ListItemText, Stack, TextField, Typography } from "@mui/material";
import { useState } from "react";

import type { ClientInfoExtended } from "../../../../../api/types/svTypes.ts";

interface DataSourceProps {
  dataSource: string;
  companies: ClientInfoExtended[];
  title: string | undefined;
  disclaimer: string;
  onChange: (company: string) => void;
  isLoading?: boolean;
  sx?: SxProps;
}
export default function DataSource({
  dataSource,
  companies,
  title,
  disclaimer,
  onChange,
  isLoading,
  sx,
}: DataSourceProps) {
  const [selectedCompany, setSelectedCompany] = useState<ClientInfoExtended | null>(
    companies.find((c) => c.clientCode === dataSource) || null
  );

  return (
    <Stack sx={{ gap: 2, ...sx }}>
      <Stack sx={{ gap: 1 }}>
        <Typography variant="subtitle2"> {title} </Typography>
        <Typography id="disclaimer">{disclaimer}</Typography>
      </Stack>
      <Stack sx={{ gap: 1 }}>
        <Autocomplete
          fullWidth
          disabled={isLoading}
          value={selectedCompany}
          onChange={(_, newValue) => {
            setSelectedCompany(newValue);
            onChange(newValue?.clientCode || "");
          }}
          getOptionLabel={(option) => option.title}
          options={companies}
          renderOption={({ key: _key, ...props }, comp) => (
            <Box component="li" sx={{ py: 0.5 }} key={comp?.clientCode || ""} {...props}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mr: 1.5,
                  bgcolor: "background.paper",
                }}
              >
                <img alt="Client Logo" style={{ width: 24, height: 24 }} src={comp?.branding.logoMarkUrl} />
              </Box>
              <ListItemText primary={comp?.title} sx={{ py: 0.5 }} />
            </Box>
          )}
          renderInput={(params) => {
            const logo = companies.find((c) => c.clientCode === selectedCompany?.clientCode)?.branding.logoMarkUrl;
            return (
              <TextField
                {...params}
                label="Data Source"
                slotProps={{
                  ...params.slotProps,
                  input: {
                    ...params.slotProps.input,
                    startAdornment: logo && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          bgcolor: "background.paper",
                          ml: 1,
                          mr: 0.5,
                        }}
                      >
                        <img
                          alt="Client Logo"
                          style={{ width: 24, height: 24 }}
                          src={selectedCompany?.branding.logoMarkUrl}
                        />
                      </Box>
                    ),
                  },
                }}
              />
            );
          }}
        />
      </Stack>
    </Stack>
  );
}
